// Translations
import form from '../sections/form/translations/de'

// Translation: Verification > Landing (German)
export default Object.freeze({
	sections: { form }
})
